import React from 'react'
import { Grid, Typography } from '@material-ui/core'

const QuarantineSubBanner = (props) => {
  const { redacted, height = 50, fontSize = 18 } = props
  const bannerText = `Warning: ${redacted ? 'Areas of the image have' : 'This entire image has'} been quarantined by an authorized supervisor.`
  return (
    <Grid container justify='center' alignItems='center' style={{ backgroundColor: 'rgb(214, 144, 0)', height: `${height}px`, width: '100%', padding: '0 .5em' }}>
      <Typography style={{ color: '#FFFFFF', fontSize, fontWeight: 600, textAlign: 'center' }}>{bannerText}</Typography>
    </Grid>
  )
}

export default QuarantineSubBanner
